import React, { ComponentType, JSX } from 'react';
import { AnalyticsTrackerProvider } from '../../containers/AnalyticsTrackerProvider';

export const withAnalyticsTracker = () => (WrappedComponent: ComponentType<unknown>) => {
  const Wrapper = (props: unknown & JSX.IntrinsicAttributes) => {
    return (
      <AnalyticsTrackerProvider>
        <WrappedComponent {...props} />
      </AnalyticsTrackerProvider>
    );
  };

  Wrapper.getInitialProps = async (data: unknown) => {
    return 'getInitialProps' in WrappedComponent &&
      typeof WrappedComponent.getInitialProps === 'function'
      ? await WrappedComponent.getInitialProps(data)
      : {};
  };

  return Wrapper;
};
